module.exports = __webpack_public_path__ + "static/img/homeNcpzx.af4741f2.png";